export const verifiedVia = (lead = {}) =>
  [lead.phoneVerified && "WhatsApp", lead.emailVerified && "Email"].filter(Boolean);

export const toLeadRow = (lead) => ({
  ...lead,
  verifiedVia: verifiedVia(lead).join(" + ") || "Not verified",
  carousel: lead.waMessageSent ? "Sent" : "Not sent",
  signedUp: lead.claimedAt ? lead.projectName || lead.assistantId : "",
});
